export default {
  breadcrumbs(state) {
    return state.breadcrumbs;
  },
  months(state) {
    return state.months;
  },
};